module.exports = __webpack_public_path__ + "img/IMG_2248_L_Black.fb4b5d91.jpg";